import React from 'react';
import PropTypes from 'prop-types';
import { browserHistory } from 'react-router';
import NextButton from '../NextButton/NextButton';

const CheckoutButton = (props) => {
  const storePaymentDetails = props.storePaymentDetails;
  const formValues = props.formValues;
  const goToPayment = () => {
    storePaymentDetails(formValues);
    browserHistory.push('/payment');
  };

  return (
    <NextButton handleClick={props.handleSubmit(goToPayment)} />
  );
};

CheckoutButton.propTypes = {
  formValues: PropTypes.object,
  storePaymentDetails: PropTypes.func,
  handleSubmit: PropTypes.func
};

export default CheckoutButton;



/** WEBPACK FOOTER **
 ** ./src/components/checkout/CheckoutButton/CheckoutButton.js
 **/